export default ({ store, next }) => {
    store.state.auth.user.roles.find((role) => {
        if (role.name == 'ess') {
            next({ name: 'Dashboard' });

            return false;
        }

        next();
    });
}